import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { memberPortal } from "./member-portal";
import { bookingFormCommon } from "./c005-bookingform-common";
import * as Cookies from 'js-cookie';
require('parsley');

export class contacttraceForm {
	private formEl: any = $('#contact-tracing-form');
	private memberBase:any = new memberPortal();
	private $loginError: Array<string> = [];
	$validationSuccess: any = true;

	$scope: any = $('#contact-tracing-form');
	private contactBase: any = new contactForm(); $error: Array<any>;

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let getQueryparam: any = _self.getUrlVars()["form"];
		if (getQueryparam == undefined) {
			if (Cookies.get('customer-contact-trace-flag') == 'true') {
				//var redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-success");
				//window.location.href = redirectURL;
				let dataDB:any;
				    dataDB ={
						'first-name' 	: Cookies.get('first-name'),
						'last-name' 	: Cookies.get('last-name'),
						'email' 		: Cookies.get('email'),
						'phone-number'  : Cookies.get('phone-number'),
						'code'			: Cookies.get('code'),
						'emailLandingPage' : 'true',
						'formFlag'		 : 'insert',
						'emailLanguage'  : $('input[name=emailLanguage]').val()
					}
					_self.updateInsertAPI(dataDB);

			}
		}

		let inputElArr: any = _self.formEl.find('input[type="text"], input[type="email"], textarea,input[type="file"]');
		_self.contactBase.initFormTextInputs(inputElArr);
	}
	updateInsertAPI = (htmlFormData: any) => {
		let bcommon: any = new bookingFormCommon();
		bcommon.preloader();
		$.ajax({
			type: 'POST',
			url: '/bin/services/new/CustomerContactTracingFormInsertUpdate',
			data: htmlFormData,
			success: function (msg: any) {
				let json: any = null;
				let firstName:any;
				let lastName:any;
				let email:any;
				let phNumber:any;
				let phcode:any
				if (typeof msg === 'string') {
					json = JSON.parse(msg);
				} else {
					json = msg;
				}
				var redirectURL;
				
				if (json.status == 'true') {
					if ( Cookies.get('second-form-sbn') == 'true'){
						redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-success-2");
					} else{
						redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-success-1");
					}

				} else {
					redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-fail");
				}
				window.location.href = redirectURL;
			}, error: function (error: any) {
				bcommon.preloaderClose();
			}
		})
	}
	/**
 * [initSelectizeInputs description]
 * @return {any} [description]
 */
	initSelectizeInputs(): any {


		let _self = this;

		var countryInput = $('#contact-tracing-form--phone-number-country-code');
		var getCountryOptions = $.Deferred();
		var getCountryOptions = $.Deferred();
		let countrycodeurl: string = '';
		if (window.location.hostname === 'localhost') {
			countrycodeurl = '/dummy-data/countrycode.json';
		}
		else {
			countrycodeurl = '/content/dam/mas/json/countrycode.json';
		}
		$.get(countrycodeurl)
			.done((data: any) => {
				var listItems = "<option value=''> </option>";
				if (window.location.hostname === 'localhost') {
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}
				}
				for (var i = 0; i < data.Countries.length; i++) {
					listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
				}
				getCountryOptions.resolve(listItems);
			})
			.fail((error: any) => {
				getCountryOptions.reject(error);
			});


		$.when(getCountryOptions).done(function (countryOptions: any) {
			countryInput.html(countryOptions);
			//let inputSelectArr: any = $.makeArray(_self.formEl.find('select'));
			//_self.contactBase.initSelectizeInputs(inputSelectArr);
		});

	}
	/**
	 * [initPhoneInput description]
	 * @return {any} [description]
	 */
	initPhoneInput(): any {
		let _self = this;

		let phoneCodeInput = $('#contact-tracing-form--code');
		let getPhoneOptions = $.Deferred();

		$.get('/content/dam/mas/json/PhoneCode.json')
			.done((data: any) => {
				let listItems = "<option value=''> </option>";
				for (let i = 0; i < data.Phonecodes.length; i++) {
					listItems += "<option value='" + data.Phonecodes[i].Code + "'>" + data.Phonecodes[i].Code + "</option>";
				}
				getPhoneOptions.resolve(listItems);
			})
			.fail((error: any) => {
				getPhoneOptions.reject(error);
			});

		$.when(getPhoneOptions).done(function (titleOptions: any) {
			phoneCodeInput.html(titleOptions);

			let inputElArr = $.makeArray(_self.formEl.find('.phoneinput'));
			//_self.formEl.initPhoneInput(inputElArr);
			//_self.contactBase.initSelectizeInputs(inputElArr);
			let inputSelectArr: any = $.makeArray(_self.formEl.find('.phoneinput'));
			_self.memberBase.initPhoneInput(inputSelectArr);
		});


		// change phone number field validation message
		let phoneNumberFields = _self.formEl.find('.phoneinput input[type="tel"]');

		phoneNumberFields.each((i: number, el: any) => {
			$(el).attr({
				'data-parsley-type-message': 'This value should be a valid number.'
			});
		});
	}
	populatedata = (getQueryparam: any) => {
		let _self = this;
		let bcommon: any = new bookingFormCommon();
		bcommon.preloader();
		var curSite = window.location.href.split('/')[4];
		if (curSite) {
		  var getLanguage = curSite;
		  if(curSite.indexOf(".") > -1) {
			getLanguage = curSite.substring(0,curSite.indexOf("."));
		  }
		}
		$.ajax({
			type: 'GET',
			url: '/bin/services/new/CustomerContactTracingFormEligibilityCheck?queryParam=' + getQueryparam+'&langSelected='+getLanguage,
			success: function (msg: any) {
				let json: any = null;
				if (typeof msg === 'string') {
					json = JSON.parse(msg);
				} else {
					json = msg;
				}
				var redirectURL;
				let phArray:any;
				let phNumber:any = json.PhoneNumber;
				if(phNumber != undefined){
					 phArray = phNumber.split("-");
				}

				bcommon.preloaderClose();
				if (json.status == 'update') {
					if(phNumber != undefined){
					_self.formEl.find("#contact-tracing-form--first-name").addClass('input-filled input-focused');
					_self.formEl.find("#contact-tracing-form--first-name").prev('label').addClass('input-filled');
					_self.formEl.find("#contact-tracing-form--first-name").val(json.firstName);

					_self.formEl.find("#contact-tracing-form--last-name").addClass('input-filled input-focused');
					_self.formEl.find("#contact-tracing-form--last-name").prev('label').addClass('input-filled');
					_self.formEl.find("#contact-tracing-form--last-name").val(json.LastName);

					_self.formEl.find("#contact-tracing-form--email").addClass('input-filled input-focused');
					_self.formEl.find("#contact-tracing-form--email").prev('label').addClass('input-filled');
					_self.formEl.find("#contact-tracing-form--email").val(json.Email);

					_self.formEl.find("#contact-tracing-form--cpcode").addClass('input-filled input-focused');
					_self.formEl.find("#contact-tracing-form--cpcode").prev('label').addClass('input-filled');
					_self.formEl.find("#contact-tracing-form--cpcode").val(phArray[1]);

					$('#contact-tracing-form--code').addClass('input-filled input-focused');
					$('#contact-tracing-form--code').prev('label').addClass('input-filled');
					setTimeout(() => {
						$('#contact-tracing-form--code').data('selectize').setValue(phArray[0]);
					}, 2000);

					
					}
				}
				else if (json.status == 'success') {
					redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-success-2");
					window.location.href = redirectURL;

				} else if (json.status == 'expired') {
					redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-expiry");
					window.location.href = redirectURL;
				}
				else {
					redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-fail");
					window.location.href = redirectURL;
				}

			}, error: function (error: any) {

			},
			cache: false,
			contentType: false,
			processData: false,
		})
	}

    getUrlVars()
	{
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	validateForm(): any {

		let _self = this;
		let submitBtn: any = _self.formEl.find('.btn-contact--submit');
		let _window: any = window;
		let bcommon: any = new bookingFormCommon();
		let validation: any;
		let getQueryparam: any = _self.getUrlVars()["form"];
		let radioSelected:any;
		$(".contact-tracing-form--booking-number").on("focus",function() {		
			radioSelected = $("input:radio[name=PNR-enrich-number-booking-number]:checked").val();	
			if(radioSelected == 'enrich-number'){	
				$('.spanMHDisp').show();
				$("#contact-tracing-form--booking-number").attr("style","padding-left:45px !important");  
			}	
		  });
		  $(".contact-tracing-form--booking-number").focusout(function () {
			let selBooingEl:any = $("#contact-tracing-form--booking-number");
			radioSelected = $("input:radio[name=PNR-enrich-number-booking-number]:checked").val();	
			if((radioSelected == 'enrich-number') && (selBooingEl.val() != '')) {	
				$('.spanMHDisp').show();
				selBooingEl.attr("style","padding-left:45px !important") 
			}else{
				$('.spanMHDisp').hide();
				selBooingEl.attr("style","");
			}
		 });

		 /* validation for pnr, ticket number and booking number */
		 $("input:radio[name=PNR-enrich-number-booking-number]").on("click",function() {
			let selBooingEl:any = $("#contact-tracing-form--booking-number");			
			radioSelected = $("input:radio[name=PNR-enrich-number-booking-number]:checked").val();	
			if((radioSelected == 'enrich-number') && (selBooingEl.val() != '')) {	
				$('.spanMHDisp').show();
				selBooingEl.attr("style","padding-left:45px !important") 
			}else{
				$('.spanMHDisp').hide();
				selBooingEl.attr("style","");
			}
			if(radioSelected == 'pnr-number'){	
				_self.formEl.find("#contact-tracing-form--booking-number").attr('maxlength', '6');	
				_self.formEl.find("#contact-tracing-form--booking-number").attr('data-parsley-type', 'alphanum');	
			}else if(radioSelected == 'enrich-number'){	
				_self.formEl.find("#contact-tracing-form--booking-number").attr('maxlength', '9');	
				_self.formEl.find("#contact-tracing-form--booking-number").attr('data-parsley-type', 'number');	
			}else if(radioSelected == 'ticket-number'){	
				_self.formEl.find("#contact-tracing-form--booking-number").attr('maxlength', '14');	
				_self.formEl.find("#contact-tracing-form--booking-number").attr('data-parsley-type', 'alphanum');
			}	

		  });

		  var curSite = window.location.href.split('/')[4];
		  if (curSite) {
			var getLanguage = curSite;
			if(curSite.indexOf(".") > -1) {
			  getLanguage = curSite.substring(0,curSite.indexOf("."));
			}
			$('input[name=langSelected]').val(getLanguage) ;
		  }

		if (getQueryparam != undefined) {
			validation = _self.formEl.parsley({
				excluded: "input[type=checkbox]",
				errorClass: 'has-error',
				classHandler: function (el: any) {
					return el.$element.closest('.form-item');
				}
			});
			_self.formEl.find('input[name=formFlag]').val('update');
			_self.formEl.find('input[name=queryParam]').val(getQueryparam);

			_self.formEl.find("#contact-tracing-form--first-name").attr('disabled', 'disabled');
			_self.formEl.find("#contact-tracing-form--last-name").attr('disabled', 'disabled');
			_self.formEl.find("#contact-tracing-form--email").attr('disabled', 'disabled');
			_self.formEl.find("#contact-tracing-form--cpcode").attr('disabled', 'disabled');
			_self.formEl.find('.phoneinput__countrycode').attr('style', 'pointer-events: none');
			_self.populatedata(getQueryparam);

		} else {
			_self.formEl.find('.contact-tracing-form--opt').hide();
			_self.formEl.find('.contact-tracing-form-booking-number').hide();
			_self.formEl.find('.contact-tracing-booking-data').hide();

			validation = _self.formEl.parsley({
				excluded: "input[type=checkbox],input[type=radio],input[name=booking-number]",
				errorClass: 'has-error',
				classHandler: function (el: any) {
					return el.$element.closest('.form-item');
				}
			});

		}

		setTimeout(() => {
			_self.formEl.find("#contact-tracing-form--code-selectized").attr('autocomplete', 'new-password');
		}, 2000);
		
		submitBtn.on('click', function (e: any) {
			e.stopPropagation();
			e.preventDefault();
			let _self = this;
			let $loginValidator: any = $('.login-validator');
			let $validationSuccess: any = true;
			$loginValidator.show();

			_self.$loginError = [];

			let validationResult: any = validation.validate();
			let $validationContainer: any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list'); let $validationMessagelist: any = $validationContainer;
			for (var i = 0, len = this.$loginError.length; i < len; i++) {
				$validationMessagelist.append('<div data-id="' + i + '" style="color: #ed1c24;font-size: .875rem;margin-left: 7px;height: 28px;">' + this.$loginError[i] + '</li>');
			}

			$('.contact-tracing-form').on('keyup', function (e: any) {
				if ($('.contact-tracing-form .error-validation').css('display') == 'block') {
					$(".fa-exclamation-triangle ").remove();
				}
				else {
					$(".fa-exclamation-triangle ").remove();
					$(".login-error--validation ").append("<div class= fa-exclamation-triangle ></div>");
				}
			});

			if (validationResult == true && $validationSuccess == false) {
				$(".fa-exclamation-triangle ").remove();
				$(".login-error--validation ").append("<div class= fa-exclamation-triangle ></div>");
			}
			else {
				$(".fa-exclamation-triangle ").remove();
			}
			if (validationResult == true && $validationSuccess == true) {

				let validation: any = $('#contact-tracing-form').parsley({
					errorClass: 'has-error',
					classHandler: function (el: any) {
						return el.$element.closest('.form-item');
					}
				});

				let htmlFormData: any = new FormData(validation.$element[0]);
				let bcommon: any = new bookingFormCommon();
				bcommon.preloader();
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/CustomerContactTracingFormInsertUpdate',
					data: htmlFormData,
					success: function (msg: any) {
						let json: any = null;
						let firstName:any;
						let lastName:any;
						let email:any;
						let phNumber:any;
						let phcode:any
						if (typeof msg === 'string') {
							json = JSON.parse(msg);
						} else {
							json = msg;
						}
						var redirectURL;
						if (json.status == 'true') {
						    Cookies.set('updateTravelDetails', json.updateTravelDetails, { expires: 30 });
							if ($('input[name=formFlag]').val() != 'update' && Cookies.get('customer-contact-trace-flag') != 'true') {
								firstName = $("#contact-tracing-form--first-name").val();
								lastName =  $("#contact-tracing-form--last-name").val();
								email = 	$("#contact-tracing-form--email").val();
								phcode =	$('#contact-tracing-form--code').val();
								phNumber = 	$("#contact-tracing-form--cpcode").val();
								Cookies.set('customer-contact-trace-flag', 'true', { expires: 30 });
								Cookies.set('first-name', firstName, { expires: 30 });
								Cookies.set('last-name', lastName, { expires: 30 });
								Cookies.set('email', email, { expires: 30 });
								Cookies.set('phone-number', phNumber, { expires: 30 });
								Cookies.set('code', phcode, { expires: 30 });
								Cookies.set('second-form-sbn', 'false', { expires: 30 });
							}else{
								Cookies.set('second-form-sbn', 'true', { expires: 30 });
							}
							if($('input[name=formFlag]').val() != 'update'){
								redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-success-1");
							}else{
								redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-success-2");
							}
							
		
						} else {
							redirectURL = $(".contact-tracing-form").attr("data-contact-tracing-fail");
						}
						window.location.href = redirectURL;
					}, error: function (error: any) {
						bcommon.preloaderClose();
					},
					cache: false,
					contentType: false,
					processData: false,
				})
				// success fuctions here
			}
			// console.log(result);
		});

		displayErrorSummaryAtFormTop();

		/**
		 * Consolidate error messages and display at the top of the form
		 */
		function displayErrorSummaryAtFormTop() {
			// When there's a click on a error message from the div
			_self.formEl.on('click', 'a[class^="focus-"]', function () {
				// take the field's name from the class
				let nameVal: string = $(this).attr('class').replace(/focus-/g, '');;
				let mabHeaderHeight: number = $('#mab-header').outerHeight();
				let errorField: any = _self.formEl.find("#" + nameVal);
				let errorFieldPos: number = 0;

				if (isSelectize(errorField)) {
					// is selectize element
					errorFieldPos = errorField.next().offset().top - mabHeaderHeight - $(window).scrollTop() - errorField.next().outerHeight();
				} else {
					// every other input field
					errorFieldPos = errorField.offset().top - mabHeaderHeight - $(window).scrollTop();
				}

				// scroll to error element
				$("html, body").animate({ scrollTop: errorFieldPos });

				// focus on the element after scrolling to it
				// - if selectize, click on input field to trigger dropdown open
				if (isSelectize(errorField)) {
					errorField.next().find('.selectize-input').click();
				} else {
					errorField.focus();
				}
			});

			if (!document.body.getAttribute('data-form-validate-init')) {
				document.body.setAttribute('data-form-validate-init', '1');
				// Before each validation, clear the error-validation of the div
				_window.Parsley.on('form:validate', function (_form: any) {

					// get scoped validation summary div
					// scoped for pages with multiple forms
					let validationSummary: any = _form.$element.find('.error-validation');

					validationSummary.html('');
					validationSummary.hide();
				});
			}

			if (!document.body.getAttribute('data-field-error-init')) {
				document.body.setAttribute('data-field-error-init', '1');
				// When a field has an error
				_window.Parsley.on('field:error', function (fieldInstance: any) {
					// console.log('field:error', fieldInstance);

					// get scoped validation summary div
					// scoped for pages with multiple forms
					let validationSummary: any = fieldInstance.parent.$element.find('.error-validation');

					// Get the error messages
					// var messages = _window.ParsleyUI.getErrorsMessages(fieldInstance);
					var messages = fieldInstance.getErrorsMessages();

					// Get the field's name
					var fieldId = fieldInstance.$element.attr('id');
					var fieldNameRaw = fieldInstance.$element.attr('name');
					var fieldName = fieldNameRaw.replace(/--/g, ' ');
					fieldName = fieldName.replace(/-/g, ' ');

					// Loop through all the messages
					for (var i in messages) {
						// Create a message for each error
						var $m = $('<p id="error--' + fieldId + '"><a class="focus-' + fieldId + '" href="#">' + '<span class="field-name">' + fieldName + ': </span>' + messages[i] + '</a><p>');

						let fieldIdExists: any = validationSummary.find('#error--' + fieldId);

						// Append the errors to the div if not shown
						if (fieldIdExists.length) {
							fieldIdExists.remove();
							validationSummary.append($m);
						} else {
							validationSummary.append($m);
						}
					}

					validationSummary.show();
				});
			}
		}

		/**
		 * test if field is selectize input
		 * @param {any} el [jquery object - input element to test]
		 * @return boolean
		 */
		function isSelectize(el: any) {
			if (el.prop('type') == 'select-one' && el.hasClass('selectized')) {
				return true;
			} else {
				return false;
			}
		}
	}

	contacttraceForm(): any {
		let _self = this;
		_self.$scope.find('#contact-tracing-form-submit').click((evt: any) => {

			var nav = $('.contact-tracing-form');
			if (nav.length) {
				var contentNav = nav.offset().top;
			}
			$('html, body').animate({ scrollTop: '100px' });
		});
	}
}
let thankScope:Element = document.querySelector('.contact-tracing-form-thank-you');
if(thankScope){
	if (Cookies.get('customer-contact-trace-flag') == 'true') {
		var phnum = Cookies.get('code') + Cookies.get('phone-number');
		$('.contact-tracing-form--fname-disp').html(Cookies.get('first-name'));
		$('.contact-tracing-form--lname-disp').html(Cookies.get('last-name'));
		$('.contact-tracing-form-email-disp').html(Cookies.get('email'));
		$('.contact-tracing-form-ph-disp').html(phnum);
		var updateTravelDetails = Cookies.get('updateTravelDetails') ;
		$("#updateTravelDetails").attr("href", updateTravelDetails);
		// $("#updateTravelDetails").html(updateTravelDetails);
	}
}
let scope: Element = document.querySelector('.contact-tracing-form');
if (scope) {
	try {
		let contacttraceform = new contacttraceForm();
		$('.form-about--success').show();
		contacttraceform.initTextInputs();
		//contacttraceform.initSelectizeInputs();
		contacttraceform.initPhoneInput();
		contacttraceform.validateForm();
		contacttraceform.contacttraceForm();


	} catch (e) { console.error(e); }
}